import { render, staticRenderFns } from "./Ahorro.vue?vue&type=template&id=19957ccc"
import script from "./Ahorro.vue?vue&type=script&lang=js"
export * from "./Ahorro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports